<template>
    <div class="home">
        <div class="vl-page">
            <div class="vl-layout">
                <div class="vl-skiplink">
                    <a href="#main">Overslaan en naar de algemene inhoud gaan</a>
                </div>
            </div>
            <!-- Pagina header -->
            <pagina-header/>

            <div id="main" itemprop="mainContentOfPage" role="main" tabindex="-1" class="vl-main-content">
                <!-- Introductie -->
                <introductie/>
                <!-- Form -->
                <div class="vl-region" style="padding-top: 16rem;">
                    <div class="vl-layout">
                        <!--Known EPC-->
                        <form @submit.prevent="validateKnownEpcForm">
                            <section class="section">
                                <div class="vl-input-group justify-content-center">
                                    <div class="vl-grid">
                                        <div class="vl-col--1-1--m vl-col--1-1--s">
                                            <label class="vl-form__label" for="wk-epc"
                                                   style="margin: 0 2rem 0 0; line-height: 35px;">Ik ken de
                                                EPC-waarde van mijn woning
                                                <span class="vl-icon vl-vi vl-vi-info-filled text-primary ml-1"
                                                      id="tooltip-known-epc"></span>
                                                <b-tooltip target="tooltip-known-epc" triggers="hover"
                                                           customClass="vl-tooltip">
                                                    <p class="vl-u-text--italic">
                                                        <span class="vl-u-text--bold">Waar vind ik de EPC-waarde?</span><br>
                                                        De EPC-waarde vindt u terug op de voorpagina van het
                                                        energieprestatiecertificaat (EPC) van uw woning
                                                        of in uw woningpas (woningpas.vlaanderen.be).
                                                        Het EPC is sinds 2009 een verplicht document bij verhuur of
                                                        verkoop van een woning.
                                                        <br><br>
                                                        Heeft u uw woning al in bezit van vóór 2009 of huurt u de
                                                        woning al van vóór 2009, dan is er meestal (nog) geen EPC
                                                        beschikbaar. Gebruik dan onderstaande test om een
                                                        indicatie van uw energielabel te krijgen of laat een
                                                        officieel EPC opmaken door een erkend energiedeskundige type
                                                        A
                                                        (<a href="https://www.energiesparen.be/epcparticulier"
                                                            target="_blank">link</a>) .
                                                        <br><br>
                                                        <span class="vl-u-text--bold">Let op!</span><br>
                                                        De EPC-waarde is niet hetzelfde als het E-peil. Het
                                                        E-peil is enkel van toepassing op nieuwbouwwoningen (gebouwd
                                                        sinds 2006) of ingrijpend gerenoveerde woningen (sinds 2015).
                                                    </p>
                                                </b-tooltip>
                                            </label>
                                        </div>
                                        <div class="vl-col--1-1--m vl-col--1-1--s vl-grid ml-0 pl-0">
                                            <div class="vl-col--1-1--s">
                                                <input type="text" name="wk-epc" id="wk-epc" class="vl-input-field"
                                                       style="max-width: 150px;" placeholder="EPC-waarde"
                                                       v-model="knownEpcForm.epc"/>
                                                <p class="vl-input-addon"
                                                   style="color: white; background: #cbd2da; font-size: 14px; padding: 0 2rem;">
                                                    kWh/m² jaar
                                                </p>
                                            </div>
                                            <div class="vl-col--1-1--s">
                                                <button type="submit" class="vl-button">
                                                    Vergelijk mijn EPC-waarde
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vl-form__error text-center"
                                     v-if="this.$v.knownEpcForm.$dirty && !this.$v.knownEpcForm.epc.required">
                                    Veld EPC-waarde is verplicht
                                </div>
                                <div class="vl-form__error text-center"
                                     v-if="this.$v.knownEpcForm.$dirty && !this.$v.knownEpcForm.epc.integer">
                                    Veld EPC-waarde moet een nummer zijn
                                </div>
                            </section>
                        </form>
                        <!-- Divider -->
                        <section class="section">
                            <div class="divider">
                                <span class="divider__label">OF</span>
                            </div>
                        </section>

                        <!-- Unknown EPC -->
                        <unknown-epc-form @submitClicked="showResult" @setAppartment="setAppartment"></unknown-epc-form>
                        <snackbar ref="snackbar" :holdTime="5000" position="top-center"/>
                    </div>
                </div>
                <!-- Resultaat -->
                <resultaat id="result" v-if="APIresult"
                           :result="APIresult" :indicatief="indicatief" :appartment="appartment"
                           :currentSituation="unknownEpcFormCopy ? unknownEpcFormCopy : knownEpcFormCopy"
                           :key="resultComponentKey" @axiosError="showError"/>
                <!-- Beter scoren -->
                <beter-scoren v-if="APIresult && indicatief"
                              :calculatedEpc="APIresult" :currentSituationProp="unknownEpcFormCopy"
                              @axiosError="showError" @improvedSituationChanged="setAxiosData"/>
                <!-- Relevante artikels -->
                <relevante-artikels v-if="APIresult" :indicatief="indicatief"/>
            </div>
        </div>
    </div>
</template>

<script>
    import PaginaHeader from '@/components/PaginaHeader';
    import Introductie from '@/components/Introductie';
    import Resultaat from '@/components/Resultaat';
    import BeterScoren from '@/components/BeterScoren';
    import RelevanteArtikels from '@/components/RelevanteArtikels';
    import UnknownEpcForm from '@/components/forms/UnknownEpcForm';
    import Snackbar from 'vuejs-snackbar';

    import {required, integer} from "vuelidate/lib/validators";
    import HttpService from "@/services/HttpService.js";

    export default {
        name: 'home',
        components: {PaginaHeader, Introductie, Resultaat, BeterScoren, RelevanteArtikels, UnknownEpcForm, Snackbar},
        data() {
            return {
                httpService: new HttpService(),
                indicatief: false,
                appartment: false,
                knownEpcForm: {
                    epc: ''
                },
                knownEpcFormCopy: null,
                APIresult: null,
                resultComponentKey: 0,
                beterScorenComponentKey: 0,
                unknownEpcFormCopy: null,
                ImprovedEpcForm: null,
                defaultDisclaimer: "De hier getoonde resultaten zijn uitdrukkelijk indicatief. Ze kunnen nooit als vervanging voor een officieel EPC beschouwd worden. Het Vlaams Energie- en Klimaatagentschap is geenszins aansprakelijk voor de juistheid of volledigheid van de getoonde informatie. Het Vlaams Energieagentschap kan in geen geval aansprakelijk worden gesteld voor directe of indirecte schade in gevolg van gebruik van deze tool. Iedere gebruiker die na deze kennisgeving gebruik maakt van de informatie, ziet af van elke klacht, van welke aard ook, in verband met het gebruik van via de tool beschikbaar gestelde informatie.",
            }
        },
      provide(){
        return {httpService: this.httpService}
      },
        validations: {
            knownEpcForm: {
                epc: {
                    required,
                    integer,
                },
            }
        },
        methods: {
            showResult(unknownEPCForm) {
                const loading = this.$loading({lock: true});
                this.APIresult = null;
                let result = new Promise((resolve) => this.setAxiosData(unknownEPCForm, resolve));
                result.then(data => {
                  this.httpService.postBerekenIndicatief(data).then(resp => {
                        this.unknownEpcFormCopy = unknownEPCForm;
                        this.resultComponentKey += 1;
                        this.beterScorenComponentKey += 1;
                        this.APIresult = this.staticApiResult();
                        this.APIresult.label = resp.data.label;
                        this.APIresult.epcScore = this.removeExtremeEpcScores(resp.data.primairEnergieverbruikPerM2);
                        this.APIresult.disclaimer = resp.data.disclaimer !== undefined ? resp.data.disclaimer : this.defaultDisclaimer;
                        this.ImprovedEpcForm = this.unknownEpcFormCopy;
                        this.indicatief = true;
                        loading.close();
                    }).catch(() => {
                        this.showError();
                        loading.close()
                    });
                });
            },
            validateKnownEpcForm() {
                this.$v.knownEpcForm.$touch();
                if (!this.$v.knownEpcForm.$invalid) {
                    this.setAppartment(false);
                    this.showResultKnownEPC();
                }
            },
            showResultKnownEPC() {
                const loading = this.$loading({lock: true});
                this.resultComponentKey += 1;
                this.APIresult = this.staticApiResult();
                if (this.knownEpcForm.epc <= 0) {
                    this.APIresult.label = 'A+';
                } else if (this.knownEpcForm.epc <= 100) {
                    this.APIresult.label = 'A';
                } else if (this.knownEpcForm.epc <= 200) {
                    this.APIresult.label = 'B';
                } else if (this.knownEpcForm.epc <= 300) {
                    this.APIresult.label = 'C';
                } else if (this.knownEpcForm.epc <= 400) {
                    this.APIresult.label = 'D';
                } else if (this.knownEpcForm.epc <= 500) {
                    this.APIresult.label = 'E';
                } else {
                    this.APIresult.label = 'F';
                }
                this.APIresult.epcScore = this.removeExtremeEpcScores(this.knownEpcForm.epc);
                this.knownEpcFormCopy = this.knownEpcForm;
                this.indicatief = false;
                loading.close();
            },
            staticApiResult() {
                return {
                    label: null,
                    epcScore: null,
                    currentPercentage: null,
                    warmtepompPct: 25,
                    pvPct: 54,
                    zonneboilerPct: 37,
                };
            },
            removeExtremeEpcScores(epcScore) {
                if (epcScore >= 999) {
                    return 998;
                } else if (epcScore <= -100) {
                    return -99;
                } else {
                    return epcScore;
                }
            },
            showError() {
                this.$refs.snackbar.error('De gegevens konden niet worden opgehaald. Probeer later opnieuw.');
            },
            setAxiosData(formData, resolve) {
                resolve({
                    "typeWoning": formData.bebouwing !== 'appartement' ? formData.bebouwing : formData.selectedAppartementType,
                    "typeGeometrie": formData.bebouwing !== 'appartement' ? formData.selectedOppervlakte : null,
                    "verwarmingEnergiedrager": formData.selectedVerwarming,
                    "typeVerwarming": formData.selectedVerwarming !== 'Warmtenet' ? formData.selectedVerwarmingDetail : null,
                    "verwarmSanitairWarmWaterMet": formData.selectedSanitairWarmWater,
                    "zonneboilerAanwezig": formData.zonneboilerCheck,
                    "pvAanwezig": formData.PVInstallatieCheck,
                    "typeVentilatie": formData.selectedVentilatie,
                    "typeDak": formData.daktype,
                    "typeHellendDakIsolatie": formData.daktype === 'Dak_hellend' || formData.daktype === 'Gemengd' ? formData.selectedHellendDak : '',
                    "typePlatDakIsolatie": formData.daktype === 'Dak_plat' || formData.daktype === 'Gemengd' ? formData.selectedPlatDak : '',
                    "typeVloer": formData.vloertype,
                    "typeVloerBovenKelderIsolatie": formData.vloertype === 'BovenKelder' || formData.vloertype === 'Gemengd' ? formData.selectedVloerBovenKelder : '',
                    "typeVloerOpVolleGrondIsolatie": formData.vloertype === 'VolleGrond' || formData.vloertype === 'Gemengd' ? formData.selectedVloerVolleGrond : '',
                    "typeGevelIsolatie": formData.selectedBuitenmuur,
                    "typeVenster": formData.selectedVenster,
                });
            },
            setAppartment(value) {
                this.appartment = value;
            }
        }
    }
</script>